import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Unauthorize  from "../pages/Unauthorize";
import { getUserRole, isAuthenticatedUser } from "../common";


const ProtectedRoute = ({ requiredUserRole }) => {
  // Example: get user info and group from cookie or context
  const isAuthenticated = isAuthenticatedUser();
  const userRole = getUserRole();
  console.log("userrole in protected doc",userRole)


  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (userRole !== requiredUserRole) {
    return <Unauthorize />;
  }

  return <Outlet />;
};

export default ProtectedRoute;